// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3OQeg","summary":"CartItem_summary__1S98l","price":"CartItem_price__3aqmq","amount":"CartItem_amount__33_Sr","actions":"CartItem_actions__1aP65"};